import { SET_USER_PRODUCT_DETAIL_FIELDS, SET_USER_PRODUCT_DETAIL, SET_PRODUCTS_USER, SET_DIALOG_PRODUCT_USER_ACTIVE } from "@/views/users/store/types";
import { initialState } from "./state";

import { updateField } from "vuex-map-fields";

const mutations = {
    [SET_USER_PRODUCT_DETAIL_FIELDS]: (state, field) => updateField(state.product, field),
    [SET_USER_PRODUCT_DETAIL]: (state, value) => state.product = !value ? { ...initialState.product } : { ...value, dataState: initialState.product.dataState },
    [SET_PRODUCTS_USER]: (state, productsUser) => state.productsUser = productsUser,
    [SET_DIALOG_PRODUCT_USER_ACTIVE]: (state, { status, index }) => state.productsUser[index]['dialogStatus'] = status,
};

export default mutations